

































import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import {Balance, BalancesDto} from "@/model/balance"
import {supportService} from "@/services/support";

@Component
export default class MsisdnBalances extends Vue {

  @Prop()
  msisdn?: string

  @Prop()
  title?: string

  @Prop()
  balances?: Balance[];

  internalBalances: Balance[] = [];

  balancesDto: BalancesDto | null = null;

  loading = false

  customerFriendly = true

  async mounted() {
    if(this.balances) {
      this.internalBalances = this.balances
    }
    await this.updateBalances();
  }

  @Watch('msisdn')
  async updateBalances() {
    if(this.msisdn) {
      this.loading = true;
      this.balancesDto = await supportService.getBalances(this.msisdn)
      this.internalBalances = this.balancesDto?.balances
      this.loading = false;
    }
  }
}
